import { render, staticRenderFns } from "./main.vue?vue&type=template&id=23249c88&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23249c88')) {
      api.createRecord('23249c88', component.options)
    } else {
      api.reload('23249c88', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=23249c88&", function () {
      api.rerender('23249c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/layouts/main.vue"
export default component.exports